import React, { forwardRef } from 'react';

import { string, func, bool } from 'prop-types';

import Loading from '../Loading';

import { ButtonStyled } from './styles';

const Button = forwardRef(
  (
    {
      color,
      name,
      width,
      onClick,
      height,
      radius,
      title,
      Icon,
      iconSize,
      fontSize,
      isLoading,
      disabled,
      showLoading,
      textColor,
      margin,
      ...others
    },
    ref
  ) => {
    function getLoadingHeight() {
      const loadHeight = parseInt(height.replace('px', ''), 10);

      return `${loadHeight - 16}px`;
    }

    return (
      <ButtonStyled
        {...others}
        ref={ref}
        bgcolor={color}
        width={width}
        onClick={onClick}
        height={height}
        title={title || name}
        iconsize={iconSize}
        font={fontSize}
        name={name}
        disabled={disabled || isLoading}
        aria-label={title || name}
        textcolor={textColor}
        margin={margin}
        radius={radius}
        disableElevation
      >
        {isLoading && showLoading && <Loading isLoading={isLoading} color="#fff" size={getLoadingHeight()} />}
        {Icon && !isLoading && <Icon />}
        {isLoading ? '' : name}
      </ButtonStyled>
    );
  }
);

Button.defaultProps = {
  showLoading: true,
  height: '40px',
  radius: '4px',
  textColor: '#ffffff',
};

Button.propTypes = {
  color: string,
  name: string,
  width: string,
  onClick: func,
  height: string,
  radius: string,
  title: string,
  Icon: func,
  iconSize: string,
  fontSize: string,
  isLoading: bool,
  disabled: bool,
  showLoading: bool,
  textColor: string,
  margin: string,
};

export default Button;
